import classNames from "classnames";
import React from "react";

import "../../../css/semantic/theme/modules/checkbox-theme.css";

export default function CheckboxControl({
  name,
  label,
  onFocus,
  onBlur,
  onChange,
  value,
  checked = !!value,
  indeterminate = false,
  disabled = false,
  readOnly = false,
  slider = false,
  toggle = false,
  toggleLabel = false,
  radio = false,
  required = false,
  className,
  hidden,
  multipleCheckboxClassName,
  ...rest
}) {
  if (value == null || value === true || value === false) {
    value = undefined;
  }

  const getValueFromEvent = (event) => {
    if (radio) {
      return event.target.value;
    } else {
      if (event.target.checked) {
        return value === undefined || value === null ? true : value;
      } else {
        return false;
      }
    }
  };
  const canToggle = () => !disabled && !readOnly && !(radio && checked);
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (canToggle()) {
      onChange && onChange(!checked && (value === undefined || value === null ? true : value));
      onBlur && onBlur();
    }
  };

  return (
    <div
      onClick={handleClick}
      className={classNames("ui checkbox", {
        [className || ""]: true,
        disabled,
        readOnly,
        checked,
        fitted: !label,
        indeterminate,
        slider,
        toggle,
        toggleLabel,
        radio,
        required,
        "multiple-checkbox": multipleCheckboxClassName,
      })}
      hidden={hidden}
    >
      <input
        ref={(elem) => elem && (elem.indeterminate = indeterminate)}
        type={radio ? "radio" : "checkbox"}
        className="hidden"
        name={name}
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        checked={checked}
        required={required}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange && ((event) => onChange(getValueFromEvent(event)))}
        {...rest}
      />
      <label>
        {label}
        {required && <span> *</span>}
      </label>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Checkbox.jsx